/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage } from 'sarsaparilla';

import SearchResultsPage from '../src/containers/SearchResultsPage';
import SearchDebugPage from '../src/containers/SearchDebugPage';

import routesArray from './routesArray';

const Components = {
    SearchResultsPage,
    SearchDebugPage,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
